export enum RegistrationTermsAndConditionsTestHooks {
  RichText = 'protection-details-terms-and-conditions',
}
